/*
 * Price tiers for the collection filters (snippets/custom-collection-facets.liquid).
 *
 * Each tier button writes Shopify's native filter.v.price.gte / .lte values into
 * the two hidden inputs of its form, then fires an `input` event so
 * assets/facets.js submits, renders and records history exactly as it does for
 * checkboxes. Pressing the active tier clears the price filter. Only one tier can
 * be active because both inputs are shared.
 */
if (!customElements.get('ds-price-tiers')) {
  customElements.define(
    'ds-price-tiers',
    class DsPriceTiers extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound) return;
        this.dataset.bound = 'true';
        // Delegated, so it keeps working after facets.js swaps the buttons.
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('[data-tier-gte]');
        if (!button || !this.contains(button)) return;

        const min = this.querySelector('input[name="filter.v.price.gte"]');
        const max = this.querySelector('input[name="filter.v.price.lte"]');
        if (!min || !max) return;

        const wasActive = button.getAttribute('aria-pressed') === 'true';
        this.querySelectorAll('[data-tier-gte]').forEach((tier) => tier.setAttribute('aria-pressed', 'false'));

        if (wasActive) {
          min.value = '';
          max.value = '';
          min.disabled = true;
          max.disabled = true;
        } else {
          min.value = button.dataset.tierGte;
          max.value = button.dataset.tierLte;
          min.disabled = false;
          max.disabled = false;
          button.setAttribute('aria-pressed', 'true');
        }

        this.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  );
}
